import { useState } from "react";
import { Button } from "./ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function BackButton({ to = "/dashboard", label = "Back to Dashboard" }) {
  const navigate = useNavigate();
  return (
    <Button
      data-testid="back-btn"
      variant="ghost"
      onClick={() => navigate(to)}
      className="text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-full"
    >
      <ArrowLeft className="w-4 h-4 mr-2" />
      {label}
    </Button>
  );
}
